import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  openLoaderWithMessage,
  closeLoaderWithMessage,
  showMessage,
} from "../redux/messages/messagesActions";
import { downloadSingleFileAsync } from "../redux/common/helpers";
import {
  getFileExtensionType,
  IFileExtension,
} from "../components/FileUploadIcon/helpers";
import { config } from "../config";

interface PreviewState {
  open: boolean;
  file: string;
  type: IFileExtension;
}

export const useFilePreview = () => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState<PreviewState>({
    open: false,
    file: "",
    type: "OTHER",
  });

  const previewFile = async (fileUrl: string | undefined) => {
    if (!fileUrl) {
      dispatch(
        showMessage({
          type: "error",
          message: "No file available to view",
          displayAs: "snackbar",
        }),
      );
      return;
    }

    let s3Url = `${config.assets.s3BaseUrl}/`;
    if (fileUrl.startsWith(s3Url)) {
      fileUrl = fileUrl.replace(s3Url, "");
    }

    const fileType = getFileExtensionType(fileUrl);

    // Excel / PDF / Image from URL direct open
    if (fileType === "EXCEL" || fileType === "CSV") {
      setPreview({ open: true, file: fileUrl, type: fileType });
      return;
    }

    // Otherwise download first
    dispatch(openLoaderWithMessage("Loading Please wait...."));
    try {
      const result = await downloadSingleFileAsync(fileUrl);
      setPreview({ open: true, file: result.data, type: result.type });
    } finally {
      dispatch(closeLoaderWithMessage());
    }
  };

  const closePreview = () => {
    setPreview({ open: false, file: "", type: "OTHER" });
  };

  return {
    preview,
    previewFile,
    closePreview,
  };
};
